import { lazy, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Toaster } from 'sonner'
import { AppSplash, HomeRedirect, ProtectedRoute } from '@/components/RouteGuards'
import { AppDataProvider } from '@/contexts/AppDataContext'
import { AuthProvider } from '@/contexts/AuthContext'
import { LoginPage } from '@/pages/LoginPage'

const EmployeeArea = lazy(() => import('@/features/employee').then((module) => ({ default: module.EmployeeArea })))
const AdminArea = lazy(() => import('@/features/admin').then((module) => ({ default: module.AdminArea })))

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppDataProvider>
          <Suspense fallback={<AppSplash />}>
            <Routes>
              <Route path="/" element={<HomeRedirect />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/admin/*" element={<ProtectedRoute role="admin"><AdminArea /></ProtectedRoute>} />
              <Route path="/*" element={<ProtectedRoute role="employee"><EmployeeArea /></ProtectedRoute>} />
            </Routes>
          </Suspense>
          <Toaster richColors closeButton position="top-right" toastOptions={{ className: 'font-sans' }} />
        </AppDataProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}
